<ul>
  <li *ngFor="let item of providers; let i = index;">
    <div fxLayoutAlign="center center" fxLayout="column">
      <span class="social-icon-holder circle border" *ngIf="!item.logo_url || item.forceDefaultLogo"
        (click)="_actionCustomProvider(item)"
        [title]="item.display_name ? item.display_name : item.provider_name | titlecase">
        <span class="social-icon" [ngClass]="'cidaas-icon-provider'"></span>
      </span>
      <span class="social-icon-holder compatible" *ngIf="item.logo_url && !item.forceDefaultLogo" (click)="_actionCustomProvider(item)"
        [title]="item.display_name ? item.display_name : item.provider_name | titlecase">
        <img [src]="item.logo_url" style="width:100%" (error)="handleImageError($event,i) "/>
      </span>
      <label>{{item.display_name ? item.display_name : item.provider_name | titlecase}}</label>
    </div>
  </li>
</ul>